import GISSolutions from 'src/pages/GISSolutions'

const GISSolutionsRoute = () => {
  return <GISSolutions />
}

export default GISSolutionsRoute
